import Swiper from "swiper";
import "swiper/css";

export default class ServicesCards {
  static init() {
    document.querySelectorAll(".services-cards").forEach((section) => {
      const sliderEl = section.querySelector(".services-cards__slider");
      if (!sliderEl) return;

      new Swiper(sliderEl, {
        slidesPerView: "auto", // Purely relies on our CSS calc()
        spaceBetween: 20,
        grabCursor: true,
        simulateTouch: true,
        allowTouchMove: true,
        observer: true,
        observeParents: true,
      });
    });
  }
}